import { isPtacSystemPreference } from '@alpinehomeair/common';
import {
  isDuctedOnlySystemPreference,
  isDuctlessOnlySystemPreference,
  isHybridOnlySystemPreference
} from './project';

export const HAS_EXISTING_EQUIPMENT_YES = 'Replacing Old System';
export const HAS_EXISTING_EQUIPMENT_NO = 'Designing New System';

export function asksHasExistingEquipment(systemPreference: unknown): boolean {
  return (
    isDuctedOnlySystemPreference(systemPreference) ||
    isHybridOnlySystemPreference(systemPreference) ||
    isPtacSystemPreference(systemPreference)
  );
}

export function hasExistingEquipmentAnswered(projectType: unknown): boolean {
  return (
    projectType === HAS_EXISTING_EQUIPMENT_YES ||
    projectType === HAS_EXISTING_EQUIPMENT_NO
  );
}

export function existingEquipmentPageVisible(
  systemPreference: unknown,
  projectType: unknown
): boolean {
  return (
    asksHasExistingEquipment(systemPreference) &&
    projectType === HAS_EXISTING_EQUIPMENT_YES
  );
}

export function equipmentPreferencesPageVisible(
  systemPreference: unknown
): boolean {
  return !isDuctlessOnlySystemPreference(systemPreference);
}

export function projectContinueTab(
  existingEquipmentVisible: boolean,
  equipmentPreferencesVisible: boolean
): 'existingEquipment' | 'equipmentPreferences' | 'structure' {
  if (existingEquipmentVisible) {
    return 'existingEquipment';
  }
  if (equipmentPreferencesVisible) {
    return 'equipmentPreferences';
  }
  return 'structure';
}

export function structureBackTab(
  existingEquipmentVisible: boolean,
  equipmentPreferencesVisible: boolean
): 'existingEquipment' | 'equipmentPreferences' | 'project' {
  if (equipmentPreferencesVisible) {
    return 'equipmentPreferences';
  }
  if (existingEquipmentVisible) {
    return 'existingEquipment';
  }
  return 'project';
}

export function equipmentPreferencesPreviousTab(
  existingEquipmentVisible: boolean
): 'existingEquipment' | 'project' {
  return existingEquipmentVisible ? 'existingEquipment' : 'project';
}
